import React, { useEffect, useRef } from 'react';
import options from '../../helpers/ContentFulOptions';
import {
  ContentfulRichTextGatsbyReference,
  renderRichText,
  RenderRichTextData,
} from '@vhub/gatsby-source-contentful/rich-text';
import { useInView } from 'react-intersection-observer';
import { updatePageView } from '../../helpers/kampyleOnsiteSDK';
import { useScrollDirection } from '../../hooks/useScrollDirection';

type ArticleBodyProps = {
  body: RenderRichTextData<ContentfulRichTextGatsbyReference>;
};

const ArticleBody: React.FC<ArticleBodyProps> = ({ body }) => {
  const scrollDirection = useScrollDirection();

  const hasFormTriggered = useRef(false);

  const { ref } = useInView({
    threshold: 1,
    initialInView: false,
    onChange: inView => {
      if (typeof window.isSurveyDisplayed === 'undefined') {
        console.error(
          'Warning: variable window.isSurveyDisplayed was not defined on initial load'
        );
      }

      if (inView && scrollDirection === 'down' && !hasFormTriggered.current) {
        hasFormTriggered.current = true;
        window.isSurveyDisplayed = true;
        updatePageView();
        return;
      }
      window.isSurveyDisplayed = false;
    },
  });

  if (!body) {
    return null;
  }

  return (
    <>
      {renderRichText(body, options)}

      <div ref={ref} />
    </>
  );
};

export default ArticleBody;
